import { Button, Form } from "react-bootstrap";

import StepIndicator from "../../../../Components/etc/StepIndicator/StepIndicator";

const StepWrapper = ({
  children,
  onPrev,
  onNext,
  disableNext,
  step,
  total,
}) => {
  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        onNext();
      }}
    >
      <StepIndicator currentStep={step} totalSteps={total} />
      {children}
      <div className="d-flex justify-content-between mt-3">
        <Button
          variant="secondary"
          type="button"
          disabled={step === 1}
          onClick={onPrev}
        >
          Prev
        </Button>
        <Button variant="primary" type="submit" disabled={disableNext}>
          Next
        </Button>
      </div>
    </Form>
  );
};

export default StepWrapper;
